import React, { PropsWithChildren, useEffect, useState } from 'react';
import { FacebookEmbed } from 'react-social-media-embed';
import {
  FacebookProvider,
  Like,
  Share,
  Login,
  Comments,
  CommentsCount,
  Page,
  EmbeddedPost,
  EmbeddedVideo,
  ShareButton
} from 'react-facebook'


/**
 * @interface IEmbedFacebookPostProps declares any input properties required for this component.
 */
export interface IEmbedFacebookPostProps extends PropsWithChildren<unknown> {
  url: string;
  postWidth: number | string;
  postHeight: number | string;
}

/**
 * @function EmbedFacebookPost is a React functional component for displaying a Facebook social media "Post".
 * @param {} props are the properties passed into the component.
 */
export const EmbedFacebookPost: React.FC<IEmbedFacebookPostProps> = (props: IEmbedFacebookPostProps) => {
  EmbedFacebookPost.displayName = 'EmbedFacebookPost';

  // whether to display console logs (displayConsoleLogs && console.log statements)
  const displayConsoleLogs: boolean = false;

  displayConsoleLogs && console.log(`EmbedFacebookPost. Entered EmbedFacebookPost`);

  const { url, postWidth, postHeight } = props;


  // The script that the react-social-media-embed component uses to load and embed Facebook posts is apparently out of date. We will load an
  // updated Facebook embed script (see https://github.com/justinmahar/react-social-media-embed/issues/53)
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    // script.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2";
    // script.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v16.0";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <FacebookEmbed url={url} width={postWidth} height={postHeight} />
    </>
  )
}
